import { Button, Dialog, DialogActions, DialogContent } from "@mui/material";
import { Component } from "react";
import DialogTitleWithCloseButton from "../../../../components/DialogTitleWithCloseButton";
import SearchAgent from "../../SearchAgent";
import { AGENT_TYPE } from "../../../../../../shared/constants";
import { errorToast } from "../../../../toast";
import { hideLoading, showLoading } from "../../../../loading";
import swal from "sweetalert";
import request from "../../../../request";


export default class AssignAgent extends Component {

   state = {
      agent: null,
   }

   submit = async () => {

      const { agent } = this.state;

      if (!agent) {
         errorToast('Please select an agent');
         return;
      };

      try {

         showLoading();

         const data = { agent: agent._id };
         await request.patch(`/api/technical/installations/${this.props.installationId}`, data);

         swal('Success', 'Agent assigned successfully', 'success');
         this.props.onClose(agent);


      } catch (err) {
         swal('Error', err.message, 'error');
      } finally {
         hideLoading();
      }

   }


   render () {

      return <Dialog open>
         <DialogTitleWithCloseButton onClose={this.props.onClose}>
            Assign Agent
         </DialogTitleWithCloseButton>

         <DialogContent dividers>
            <div className="w-[300px]">
               <SearchAgent
                  type={AGENT_TYPE.TECHNICAL}
                  onChange={agent => this.setState({ agent })}
               />
            </div>
         </DialogContent>
         <DialogActions>
            <Button variant='contained' onClick={this.submit}>
               SUBMIT
            </Button>
         </DialogActions>
      </Dialog>
   }
}